import type { Heading } from "../types/global";

export const heroHeading: Heading = {
    heading: "Recording & rehearsal studio on Vancouver Island",
    paragraph: "Strangeways is a turnkey recording and rehearsal studio on Vancouver Island with a large sound stage wired for fast, no-nonsense sessions. You're tracking multitrack audio through Class-A converters and preamps within minutes, with multicam HD video and Sessionwire remote access available out of the box. From indie bands to choirs and jazz or string ensembles, the room, routing, and rates are tuned for artists who need great results without burning time or budget."
}

export const heroSubheading: string[] = [
    "Optimised for independent artists",
    "Pristine multitrack audio + HD video",
    "Remote collaboration via Sessionwire"
]